export default __webpack_public_path__ + "static/media/portfolio-details-section.3cf4bd1b.svg";